import { useNavigation } from '@atom/hooks/useNavigation';
import { InventoryAssetDetailType } from '@atom/types/inventory';
import { getGoogleShapeCenter } from '@atom/utilities/mapUtilities';
import schemaUtilities from '@atom/utilities/schemaUtilities';
import textDisplayUtilities from '@atom/utilities/textDisplayUtilities';
import timeUtilities from '@atom/utilities/timeUtilities';

import classes from './drawerContent.module.css';

interface Props {
  asset: InventoryAssetDetailType;
  navigateToAsset: (id: string) => void;
}

const AssetListItem = ({ asset, navigateToAsset }: Props) => {
  const centerLocation = getGoogleShapeCenter(asset.location);
  const icon = schemaUtilities.getSchemaIconFromSchemaOrAsset(asset);
  const [, { updateSearchParams }] = useNavigation();

  const onMouseEnter = () => {
    updateSearchParams({ hover: asset.id });
  };

  const onMouseLeave = () => {
    updateSearchParams({ hover: null });
  };

  return (
    <div
      className={classes.assetRowContainer}
      onClick={() => navigateToAsset(asset.id)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={classes.assetListLegendContainer}>{icon}</div>
      <div>
        <div className={classes.assetNameContainer}>{asset.name}</div>
        <div
          className={classes.assetContentContainer}
        >{`Lat & Long: ${textDisplayUtilities.latLong(
          centerLocation.lat,
        )}, ${textDisplayUtilities.latLong(centerLocation.lng)}`}</div>
        <div className={classes.assetContentContainer}>
          {`Last Updated: ${timeUtilities.setDisplayDate(asset.updatedDate)}`}
        </div>
      </div>
    </div>
  );
};

export default AssetListItem;
